import { NgModule } from '@angular/core';
import {
  NgbAlertModule,
  NgbDatepickerModule,
  NgbModule,
  NgbTooltip,
  NgbTooltipModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModuleDataOrder } from './components/table-data-order/shared/shared.module';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { PickupOrderComponent } from './pickup-order/pickup-order.component';
import { CommonModule } from '@angular/common';
import { LibsModule } from 'src/app/libs/libs.module';
import { NgLabelTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { DataOrderRoutingModule } from './data-order-routing.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import { DataOrderComponent } from './data-order.component';
import { TableDataOrderComponent } from './components/table-data-order/table-data-order.component';
import { DetailDataOrderComponent } from './detail-data-order/detail-data-order.component';
import { OrderInformationComponent } from './detail-data-order/components/order-information/order-information.component';
import { ShippingInfoDefaultComponent } from './detail-data-order/components/shipping-info-default/shipping-info-default.component';
import { ShippingInfoGosendComponent } from './detail-data-order/components/shipping-info-gosend/shipping-info-gosend.component';
import { PaymentSummaryComponent } from './detail-data-order/components/payment-summary/payment-summary.component';
import { AwbHistoryModalComponent } from './detail-data-order/components/awb-history-modal/awb-history-modal.component';

@NgModule({
  declarations: [
    DataOrderComponent,
    TableDataOrderComponent,
    DetailDataOrderComponent,
    PickupOrderComponent,
    OrderInformationComponent,
    ShippingInfoDefaultComponent,
    ShippingInfoGosendComponent,
    PaymentSummaryComponent,
    AwbHistoryModalComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgbAlertModule,
    NgbDatepickerModule,
    NgbTooltip,
    NgbTooltipModule,
    NgbTypeaheadModule,
    SharedModuleDataOrder,
    AntDModule,
    CommonModule,
    LibsModule,
    NgbModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    DataOrderRoutingModule,
    NgxDaterangepickerMd
  ],
})
export class DataOrderModule {}
